"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConverter = exports.queryAccessor = exports.documentAccessor = void 0;
const firestore_1 = require("firebase/firestore");
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const firestore_2 = require("comodel/firestore");
const queryUtil_1 = require("./queryUtil");
const function_client_1 = require("common/function-client");
const eventLogger_1 = require("./eventLogger");
const models_1 = require("common/models");
const auth_1 = require("firebase/auth");
function chunkArray(arr, chunkSize) {
    const chunks = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
    }
    return chunks;
}
const firestore = (0, firestore_1.getFirestore)(firebase_app_1.default);
const auth = (0, auth_1.getAuth)(firebase_app_1.default);
const user = () => auth.currentUser
    ? {
        uid: auth.currentUser.uid,
        email: auth.currentUser.email,
        displayName: auth.currentUser.displayName,
        photoURL: auth.currentUser.photoURL,
    }
    : null;
const logCollectionRef = (0, firestore_1.collection)(firestore, models_1.logDefinition.collectionName);
const eventLogger = new eventLogger_1.FirestoreEventLogger(logCollectionRef);
const enableAudit = true;
const executeUpdateRequest = (data, options) => __awaiter(void 0, void 0, void 0, function* () {
    (0, firestore_2.cleanObject)(data);
    console.log("executeUpdateRequest", data, options === null || options === void 0 ? void 0 : options.audit);
    if (enableAudit && (options === null || options === void 0 ? void 0 : options.audit)) {
        yield (0, function_client_1.performAction)(data);
    }
    else {
        const chunks = chunkArray(data.records, 500);
        for (const chunk of chunks) {
            const batch = (0, firestore_1.writeBatch)(firestore);
            for (const record of chunk) {
                const { type, data, path } = record;
                const ref = (0, firestore_1.doc)(firestore, path);
                switch (type) {
                    case "set":
                        batch.set(ref, data);
                        break;
                    case "update":
                        batch.update(ref, data);
                        break;
                    case "merge":
                        batch.set(ref, data, { merge: true });
                        break;
                    case "delete":
                        batch.delete(ref);
                        break;
                }
            }
            yield batch.commit();
        }
    }
});
const getDocRef = (collectionDef, data) => {
    const path = collectionDef.docPath(data);
    return path
        ? (0, firestore_1.doc)(firestore, path).withConverter((0, exports.getConverter)(collectionDef))
        : undefined;
};
const prepareSet = (collectionDef, constraint, data, { merge, } = {}) => {
    let _data = collectionDef.mergeConstraint(data, constraint);
    _data = collectionDef.onAccess(_data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!_data[collectionDef.idKey]) {
        _data = Object.assign(Object.assign({}, _data), { [collectionDef.idKey]: collectionDef.onGenerateIdKey(_data) });
        _data = collectionDef.onGenerate(_data);
    }
    _data = collectionDef.onWrite(_data);
    return Object.assign({ type: merge ? "merge" : "set", data: collectionDef.toFirestore(_data), constraint, dataConstraint: collectionDef.toFirestore(collectionDef.onAccess(constraint)) }, prepareParams(collectionDef, _data));
};
const prepareDelete = (collectionDef, constraint) => {
    const _data = collectionDef.onAccess(constraint);
    return Object.assign({ type: "delete", constraint, dataConstraint: collectionDef.toFirestore(collectionDef.onAccess(constraint)) }, prepareParams(collectionDef, _data));
};
const prepareParams = (collectionDef, _data) => {
    const path = collectionDef.docPath(_data);
    const collectionPath = collectionDef.collectionPath(_data);
    const id = _data[collectionDef.idKey];
    if (!path || !id || !collectionPath) {
        console.error("unsatisfied constraint", _data);
        throw new Error("unsatisfied constraint");
    }
    return {
        // id,
        // collectionPath,
        collectionName: collectionDef.collectionName,
        path,
    };
};
const set = (collectionDef_1, constraint_1, data_1, ...args_1) => __awaiter(void 0, [collectionDef_1, constraint_1, data_1, ...args_1], void 0, function* (collectionDef, constraint, data, { merge, } = {}, log) {
    var _a;
    const record = prepareSet(collectionDef, constraint, data, {
        merge,
    });
    yield executeUpdateRequest({
        type: merge ? "merge" : "set",
        collectionName: collectionDef.collectionName,
        constraint,
        records: [record],
    }, { audit: collectionDef.audit });
    if (log) {
        eventLogger === null || eventLogger === void 0 ? void 0 : eventLogger.add(Object.assign(Object.assign({}, constraint), { user: user(), action: merge ? "upsert" : "set", details: (_a = (0, firestore_2.cleanObject)(data)) !== null && _a !== void 0 ? _a : null }));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _data = record.data;
    return { [collectionDef.idKey]: _data[collectionDef.idKey] };
});
const setAtomic = (collectionDef_2, constraint_2, data_2, _b, log_1) => __awaiter(void 0, [collectionDef_2, constraint_2, data_2, _b, log_1], void 0, function* (collectionDef, constraint, data, { merge, onUpdate, }, log) {
    let _data = collectionDef.mergeConstraint(data, constraint);
    _data = collectionDef.onAccess(_data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!_data[collectionDef.idKey]) {
        _data = Object.assign(Object.assign({}, _data), { [collectionDef.idKey]: collectionDef.onGenerateIdKey(_data) });
        _data = collectionDef.onGenerate(_data);
    }
    _data = collectionDef.onWrite(_data);
    const ref = getDocRef(collectionDef, _data);
    if (!ref) {
        console.error("unsatisfied constraint", _data);
        throw new Error("unsatisfied constraint");
    }
    yield (0, firestore_1.runTransaction)(firestore, (transaction) => __awaiter(void 0, void 0, void 0, function* () {
        const snapshot = yield transaction.get(ref);
        _data = onUpdate(_data, snapshot.data());
        if (!_data) {
            return;
        }
        if (merge) {
            transaction.set(ref, _data, { merge: true });
        }
        else {
            transaction.set(ref, _data);
        }
        if (log) {
            eventLogger === null || eventLogger === void 0 ? void 0 : eventLogger.add(Object.assign(Object.assign({}, constraint), { user: user(), action: "setAtomic", details: {
                    newData: (0, firestore_2.cleanObject)(_data),
                    oldData: (0, firestore_2.cleanObject)(snapshot.data()),
                } }));
        }
    }));
    return { [collectionDef.idKey]: _data[collectionDef.idKey] };
});
const documentAccessor = (collectionDef, constraint, log) => {
    const _constraint = collectionDef.onAccess(constraint);
    const ref = getDocRef(collectionDef, _constraint);
    const defaultValue = Object.assign(Object.assign({}, _constraint), collectionDef.defaultValue);
    return {
        defaultValue,
        ref,
        set: (data) => __awaiter(void 0, void 0, void 0, function* () {
            return set(collectionDef, _constraint, data, {}, log);
        }),
        setAtomic: (data, onUpdate) => __awaiter(void 0, void 0, void 0, function* () {
            return setAtomic(collectionDef, _constraint, data, { onUpdate }, log);
        }),
        upsert: (data) => __awaiter(void 0, void 0, void 0, function* () {
            return set(collectionDef, _constraint, data, { merge: true }, log);
        }),
        remove: () => __awaiter(void 0, void 0, void 0, function* () {
            const record = prepareDelete(collectionDef, _constraint);
            if (ref) {
                yield executeUpdateRequest({
                    type: "delete",
                    collectionName: collectionDef.collectionName,
                    constraint: _constraint,
                    records: [record],
                }, { audit: collectionDef.audit });
                if (log) {
                    eventLogger === null || eventLogger === void 0 ? void 0 : eventLogger.add(Object.assign(Object.assign({}, _constraint), { user: user(), action: "remove" }));
                }
            }
        }),
    };
};
exports.documentAccessor = documentAccessor;
const queryAccessor = (collectionDef, constraint, queryParams, group) => {
    const ref = (() => {
        const collectionRef = (() => {
            if (group) {
                return (0, firestore_1.collectionGroup)(firestore, collectionDef.collectionName);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const path = collectionDef.collectionPath(constraint);
            if (path) {
                return (0, firestore_1.collection)(firestore, path);
            }
        })();
        return (collectionRef &&
            (0, firestore_1.query)(collectionRef, ...(0, queryUtil_1.getQueryConstraints)(Object.assign(Object.assign({}, queryParams), { idKey: collectionDef.idKey }))).withConverter((0, exports.getConverter)(collectionDef)));
    })();
    return {
        ref,
        remove: (data) => __awaiter(void 0, void 0, void 0, function* () {
            const record = prepareDelete(collectionDef, data);
            yield executeUpdateRequest({
                type: "delete",
                collectionName: collectionDef.collectionName,
                constraint: data,
                records: [record],
            }, { audit: collectionDef.audit });
        }),
        set: (data) => {
            return set(collectionDef, constraint, data);
        },
        upsert: (data) => {
            return set(collectionDef, constraint, data, { merge: true });
        },
        upload: (list) => {
            const records = list.map((data) => prepareSet(collectionDef, constraint, data, {
                merge: true,
            }));
            return executeUpdateRequest({
                type: "upload",
                constraint,
                collectionName: collectionDef.collectionName,
                records,
            }, {
                audit: collectionDef.audit,
            });
        },
        prepareUpload: (list) => {
            const records = list.map((data) => prepareSet(collectionDef, constraint, data, {
                merge: true,
            }));
            return records;
        },
        get: () => __awaiter(void 0, void 0, void 0, function* () {
            if (!ref) {
                return;
            }
            const snapshot = yield (0, firestore_1.getDocs)(ref);
            return snapshot.docs.map((item) => item.data());
        }),
    };
};
exports.queryAccessor = queryAccessor;
const getConverter = (collectionDef) => {
    const converter = {
        toFirestore: (original) => {
            return collectionDef.toFirestore(original);
        },
        fromFirestore: (snapshot) => {
            return collectionDef.fromFirestore(snapshot.data(), snapshot.ref.path);
        },
    };
    return converter;
};
exports.getConverter = getConverter;
